import { ToIri } from 'types/embedded/utility';

export const convertReactAdminIdToHydraId = <Entity extends string, Id extends string | number>(
  id: Id,
  resource: Entity,
): ToIri<Entity, `${Id}`> => {
  return `/admin/${resource}/${id}` as ToIri<Entity, `${Id}`>;
};
